import React from 'react';
import * as S from './styled';

// eslint-disable-next-line react/jsx-filename-extension
const Backdrop = props => <S.Backdrop {...props} />;

export default Backdrop;
